import { Stack, Typography } from '@mui/material';
import { DialogComponentProps, useDialog } from 'common/hooks/useDialog';
import { format } from 'date-fns';
import { sk } from 'date-fns/locale';
import { FilterOperator, ReportType, SortDirection, useReportsQuery } from 'generated/graphql';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FintelligenceReportIcon } from '../../../assets/icons/FintelligenceReportIcon.svg';
import { ReactComponent as FintelligenceReportInactiveIcon } from '../../../assets/icons/FintelligenceReportInactiveIcon.svg';
import { ReportWidget } from '../ReportWidget/ReportWidget';
import { FintelligenceReportIntroDialog } from './FintelligenceReportIntroDialog/FintelligenceReportIntroDialog';

export const FintelligenceReportWidget: React.FC = () => {
  const { t } = useTranslation();

  const { data } = useReportsQuery({
    variables: {
      filterInput: {
        arguments: [
          {
            filterCondition: {
              fieldPath: 'type',
              operator: FilterOperator.Equal,
              values: [ReportType.Fintelligence],
            },
          },
        ],
      },
      sortInput: { by: [{ direction: SortDirection.Desc, fieldPath: 'creationTimestamp' }] },
    },
  });

  const latestReport = data?.reports.items?.[0];
  const updateDate = latestReport?.creationTimestamp;
  const active = latestReport !== undefined;

  const fintelligenceReportIntroDialog = useDialog<DialogComponentProps<void>, void>(FintelligenceReportIntroDialog, {
    instanceId: 'fintelligence-report-intro-dialog',
    navigable: true,
  });

  const handleShowFintelligenceReportIntroDialog = () => {
    fintelligenceReportIntroDialog.create({});
  };

  return (
    <ReportWidget active={active} onClick={handleShowFintelligenceReportIntroDialog}>
      <Stack direction="row" gap={2}>
        {active ? <FintelligenceReportIcon /> : <FintelligenceReportInactiveIcon />}
        <Stack>
          <Typography variant="bodyStrongL"> {t('fintelligenceReport.widget.title')}</Typography>
          <Typography variant="bodyM">
            {active
              ? t('fintelligenceReport.widget.updateDate', {
                  date: format(updateDate ?? new Date(), 'dd. MMMM', { locale: sk }),
                })
              : t('fintelligenceReport.widget.subtitle')}
          </Typography>
        </Stack>
      </Stack>
    </ReportWidget>
  );
};
